export interface PetRegistry {
  id: number;
  residentId: number;
  petName: string;
  petNameKey?: string;
  petType: PetType;
  breed?: string;
  breedKey?: string;
  age?: number;
  weight?: number;
  color?: string;
  colorKey?: string;
  microchipId?: string;
  vaccinationRecords: VaccinationRecord[];
  registrationDate: Date;
  expiryDate?: Date;
  isActive: boolean;
  specialNeeds?: string;
  specialNeedsKey?: string;
  emergencyContact?: string;
  vetName?: string;
  vetNameKey?: string;
  vetContact?: string;
  photos?: string[];
  notes?: string;
  notesKey?: string;
}

export enum PetType {
  DOG = 'dog',
  CAT = 'cat',
  BIRD = 'bird',
  FISH = 'fish',
  HAMSTER = 'hamster',
  RABBIT = 'rabbit',
  REPTILE = 'reptile',
  OTHER = 'other',
}

export interface VaccinationRecord {
  id: number;
  petId: number;
  vaccineName: string;
  administeredDate: Date;
  expiryDate: Date;
  vetName?: string;
  vetClinic?: string;
  batchNumber?: string;
  nextDueDate?: Date;
}

export interface PetPolicy {
  id: number;
  title: string;
  description: string;
  petType: PetType;
  maxPetsPerUnit: number;
  weightLimit?: number;
  breedRestrictions?: string[];
  requiredVaccinations: string[];
  registrationFee?: number;
  monthlyFee?: number;
  currency?: string;
  isActive: boolean;
  effectiveDate: Date;
  expiryDate?: Date;
}
